// src/components/shared/constants/industries.js
// 80+ detailed industries for project creation typeahead.
// Combines Meta ad categories, LinkedIn industry list, and common gaps.

export const INDUSTRIES = [
  "Accounting & Financial Services",
  "Agriculture & Farming",
  "AI & Machine Learning",
  "Architecture & Interior Design",
  "Arts & Crafts",
  "Automotive & Vehicles",
  "Aviation & Aerospace",
  "Beauty & Cosmetics",
  "Biotechnology & Life Sciences",
  "Blockchain & Cryptocurrency",
  "Books & Publishing",
  "Business Consulting",
  "Cannabis & Hemp",
  "Charity & Nonprofits",
  "Childcare & Parenting",
  "Cleaning & Janitorial Services",
  "Coaching & Personal Development",
  "Construction & Contracting",
  "Cybersecurity & Privacy",
  "Dance & Performing Arts",
  "Dating & Relationships",
  "Dental & Orthodontics",
  "E-commerce & Retail",
  "Education & E-Learning",
  "Electronics & Consumer Tech",
  "Energy & Utilities",
  "Engineering & Manufacturing",
  "Entertainment & Media",
  "Environmental & Sustainability",
  "Event Planning & Management",
  "Fashion & Apparel",
  "Film & Video Production",
  "Finance & Banking",
  "Fitness & Gyms",
  "Food & Beverage",
  "Freelancing & Gig Economy",
  "Furniture & Home Decor",
  "Gaming & Esports",
  "Government & Public Sector",
  "Graphic Design & Branding",
  "Hair & Barbering",
  "Healthcare & Medical",
  "Hospitality & Hotels",
  "Human Resources & Recruitment",
  "Import & Export",
  "Insurance",
  "Jewellery & Accessories",
  "Journalism & News",
  "Law & Legal Services",
  "Logistics & Supply Chain",
  "Luxury Goods & Services",
  "Marketing & Advertising",
  "Mental Health & Therapy",
  "Mining & Resources",
  "Mobile Apps & Software",
  "Music & Audio Production",
  "Nutrition & Dietetics",
  "Outdoor & Adventure",
  "Pets & Veterinary",
  "Pharmaceuticals",
  "Photography",
  "Podcasting & Content Creation",
  "Politics & Advocacy",
  "Printing & Signage",
  "Property & Real Estate",
  "Public Relations & Communications",
  "Religion & Spirituality",
  "Restaurants & Food Service",
  "SaaS & Cloud Computing",
  "Science & Research",
  "Security & Protection Services",
  "Senior Care & Assisted Living",
  "Skincare & Wellness",
  "Social Media & Influencer",
  "Sports & Athletics",
  "Staffing & Employment Agencies",
  "Tattoo & Body Art",
  "Technology & Software",
  "Telecommunications",
  "Textiles & Fabrics",
  "Tourism & Travel",
  "Transportation & Delivery",
  "Venture Capital & Startups",
  "Video Games & Interactive Media",
  "Web Development & Design",
  "Wedding & Bridal",
  "Wine, Beer & Spirits",
  "Yoga & Meditation",
];
